import {
  DEALER_LISTING_REQUEST,
  DEALER_LISTING_FAIL,
  DEALER_LISTING_SUCCESS,
  DEALER_LISTING_UPDATE_USER_STATUS,
  DEALER_PHONE,
  VERIFIED_DEALER_EMAIL
} from "../../constants/actions.js";
import { ApiURLs } from "../../../constant/ApiUrls.jsx";
import { fetchData, postData, updateData, uploadImage } from "../../../services/api.js";
import { hideAddDealerModal } from "./dealerModalDispatcher.js";

export const dealerListingRequest = (sortField, sortOrder, page = 1, pageSize = 50, keyword = '') => {
  return async (dispatch) => {
    const url = `${ApiURLs.GET_DEALERS}?sortField=${sortField}&sortOrder=${sortOrder}&page=${page}&limit=${pageSize}&keyword=${keyword}&vendor_type=dealer&users.dealer_id=0`;

    dispatch(dealerListingReq());
    try {
      const dealerResData = await fetchData(url);
      console.log(`response for dealer listing ${JSON.stringify(dealerResData)}`);
      if (dealerResData.status === 1) {
        dispatch(dealerListingSuccess(dealerResData.data));
      } else {
        dispatch(dealerListingFailure());
      }
    } catch (error) {
      dispatch(dealerListingFailure());
      console.log(`error while fetching dealer listing ${error}`);
    }
  };
};

export const dealerListingReq = () => {
  return {
    type: DEALER_LISTING_REQUEST,
  };
};

export const dealerListingSuccess = (dealers) => {
  return {
    type: DEALER_LISTING_SUCCESS,
    payload: dealers,
  };
};

// actions/dealerActions.js
export const dealerListingUpdateUserStatus = (dataToBeUpdate) => ({
  type: DEALER_LISTING_UPDATE_USER_STATUS,
  payload: dataToBeUpdate,
});

// actions/dealerActions.js
export const dealerPhone = (dataToBeUpdate) => ({
  type: DEALER_PHONE,
  payload: dataToBeUpdate,
});

export const dealerListingFailure = () => {
  return {
    type: DEALER_LISTING_FAIL,
  };
};




export const verifiedUserEmail = (dataToBeUpdate) => ({
  type: VERIFIED_DEALER_EMAIL,
  payload: dataToBeUpdate,
});



export const addDealerRequest = (data) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_DEALER_REQUEST" });

    try {
      // Upload profile image if exists
      if (data.image) {
        const uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE,
          "image",
          data.image,
          "dealer"
        );
        console.log("Upload Image Response:", uploadedImage);
        data.image = uploadedImage.data.file.path; // replace local file with server URL
      }




      if (data.bg_image) {
        const uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE,
          "image",
          data.bg_image,
          "dealer-bg-image"
        );
        console.log("Upload Image Response:", uploadedImage);
        data.bg_image = uploadedImage.data.file.path; // replace local file with server URL
      }



      if (data.logo) {
        const uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE,
          "image",
          data.logo,
          "dealer-logo"
        );
        console.log("Upload Image Response:", uploadedImage);
        data.logo = uploadedImage.data.file.path; // replace local file with server URL
      }

      let dealerResponse;
      if (data.id) {
        // Update existing dealer
        dealerResponse = await updateData(data, `${ApiURLs.UPDATEDEALER}`);
      } else {
        // Add new dealer
        dealerResponse = await postData(data, ApiURLs.CREATEDEALER);
      }

      if (dealerResponse.status === 1) {
        dispatch({ type: "ADD_DEALER_SUCCESS" });
        dispatch(hideAddDealerModal());
        // Refresh dealer list (optional: could filter by parent/location if needed)
        dispatch(dealerListingRequest('created_at', 'desc', 1, 50, ""));


        return true;
      } else {
        dispatch({ type: "ADD_DEALER_FAILED" });
        return false;

      }
    } catch (error) {
      console.error("Add Dealer Error:", error);
      dispatch({ type: "ADD_DEALER_FAILED" });
      return false;

    }
  };
};




export const addBumpSpotlightRequest = (data) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_BUMP_SPOTLIGHT_REQUEST" });

    try {
      const dealerResponse = await updateData(data, `${ApiURLs.ADD_BUMP_SPOTLIGHT}`);

      if (dealerResponse.status === 1) {
        dispatch({ type: "ADD_BUMP_SPOTLIGHT_SUCCESS" });
        dispatch(hideAddDealerModal());
        dispatch(dealerListingRequest('created_at', 'desc', 1, 50, ""));
        return Promise.resolve(true);
      } else {
        dispatch({ type: "ADD_BUMP_SPOTLIGHT_FAILED" });
        return Promise.resolve(false);
      }
    } catch (error) {
      console.error("Add Dealer Error:", error);
      dispatch({ type: "ADD_BUMP_SPOTLIGHT_FAILED" });
      return Promise.reject(false);
    }
  };
};
